<template>
  <div id="wdc-app" class="wdc-app">
    <router-view />
    <van-tabbar
      v-if="$route.name && !NoTabBar.includes($route.name)"
      class="tabbar-box"
      v-model="tabbar.active"
      v-show="tabbar.show"
      active-color="#3760FF"
    >
      <van-tabbar-item name="home" @click="gopage('home')">
        <img
          class="nav-icon"
          :src=" $route.name == 'home' 
              ? require('./assets/images/home/home-2.png')
              : require('./assets/images/home/home-1.png')
          "
        />
        <br />
        首页
      </van-tabbar-item>


      <van-tabbar-item name="activity" @click="gopage('activity')">
        <img
          class="nav-icon"
          :src="
            $route.name == 'activity'
              ? require('./assets/images/home/goods_active.png')
              : require('./assets/images/home/goods_noAcitve.png')
          "
        />
        <br />
        活动
      </van-tabbar-item>

      <van-tabbar-item name="learning" @click="gopage('learning')">
        <img
          class="nav-icon"
          :src="
            $route.name == 'learning'
              ? require('./assets/images/home/learing-2.png')
              : require('./assets/images/home/learing-1.png')
          "
        />
        <br />
        学习
      </van-tabbar-item>
      <van-tabbar-item name="saccount" @click="gopage('saccount')">
        <img
          class="nav-icon"
          :src="
            $route.name == 'saccount'
              ? require('./assets/images/home/account-2.png')
              : require('./assets/images/home/account-1.png')
          "
        />
        <br />
        我的
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import { mapState } from "vuex";
import store from './store/index';
import URL from './config/url';
let loadedAMapJS = false // 是否加载完js
import {
    loadExternalCSS,
    loadExternalJS
} from 'wdn-h5/src/tools.js'
export default {
  data () {
    return {
      bannerItems: [],
      getUserInfo: true,
      active: 'home',
      frontendConfig: null,
      NoTabBar:['login', 'verification','trialClass','applaypage','verificationCode','liveSkip','promotionCenter', 'promotionCenterMine', 'cumulativeRevenueList', 'cumulativeRevenueDetail', 'seeTuiguangQrcode'],// 页面不需要显示tabbar
      showTabbar:['learning','saccount','goodsList','home','activity'], // 页面需要显示tabber
    };
  },
  computed: {
    ...mapState(["tabbar"]),
  },
  watch: {
    $route () {
      if (this.showTabbar.includes(this.$route.name)) {
        this.tabbar.show = true
      } else {
        this.tabbar.show = false
      }
      this.renderPage();
    },
  },
  components: {},
  created () {
    console.log('--------------')
    this.loader();
    let url= URL.confUrl
    this.renderPage();
    this.configMenuInfor()
  },
  mounted () {
    console.log('$route.name',this.$route.name)
    document.addEventListener('visibilitychange', () => {
        var isHidden = document.hidden;
        if (!isHidden) {
          let localStorageId = localStorage.getItem('WDuserInfo') && JSON.parse(localStorage.getItem('WDuserInfo')).accountId
          let vuexId = this.$store.state.userInfo.accountId
          console.log(localStorageId,vuexId)
          if(localStorageId && vuexId && localStorageId !== vuexId){//重新加载页面，保持账号同步
            // this.$router.replace('/')
            this.$router.go(0)
          }
        }
    })
  },
  methods: {
     loader: function() {
          loadExternalJS(['https://web.sdk.qcloud.com/player/tcplayerlite/release/v2.4.1/TcPlayer-2.4.1.js',
          ]);
          loadExternalCSS(['https://imgcache.qq.com/open/qcloud/video/tcplayer/tcplayer.css']);
          console.log('TcPlayer数据已经加载成功');
      },
    gopage(name){
      this.$router.push({ name })
    },
    async init () {
    },
    renderPage () {
      const { meta, params } = this.$route;
      this.config = store.getters.getPageConfigs(
        meta.moduleId,
        meta.name,
      );
      this.routerParams = params;
    },
    async getAccountUserInfo () {
      const headers = {
        "token": localStorage.getItem('token')
      }
      return this.$api.usercenter.getAccountUserInfo({ headers }).then(res => {
        if (res.data) {
          this.$store.state.userInfo = {
            ...this.$store.state.userInfo,
            ...res.data
          }
          localStorage.setItem('WDuserInfo', JSON.stringify(this.$store.state.userInfo))
        }
      })
    },
    configMenuInfor(){
        this.$api.home.getMenuNew().then((res) => {

            if (res.data.menuList) {
                this.getActiveNav(res.data.menuList);
            } else {
                console.log('123')
            }
        })
    },
    getActiveNav(navName) {
        navName.forEach((d)  => {
        switch(d.url) {
            case "/goodsList" :
              this.isShowGoodsList = true
              break;

            default:
              break
        }

      })
    }
  }
};
</script>

<style lang="stylus">
html,body,.wdc-app {
  height: 100%;
}

.van-notify--danger {
    background-color: #ee0a24 !important;
}

.van-tabbar--fixed {
  padding-bottom: 0px;
  position: fixed !important;
  bottom: 0;
  left: 0;
}

.van-tabbar-item__text {
  text-align: center;
}

.nav-icon {
  width: 44px;
}
.wanghong

.text {
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
  margin-top: 5px;
}
input:-webkit-autofill,
textarea:-webkit-autofill,
select:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px white inset;
  -webkit-text-fill-color: #333;
}
input[type=text]:focus, input[type=password]:focus, textarea:focus {
  -webkit-box-shadow: 0 0 0 1000px white inset;
}
</style>
